module.exports = __webpack_public_path__ + "img/a8.4e66b6b1.png";